import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Ruler, ChevronRight } from "lucide-react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Skeleton } from "@/components/ui/skeleton";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Input } from "@/components/ui/input";

// Admin/Trainer hub: pick a member to view/enter measurements (opens member detail measurement tab)
export default function AdminMeasurements({ base = "/admin" }) {
  const navigate = useNavigate();
  const [members, setMembers] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/members").then((r) => setMembers(r.data)); }, []);

  const filtered = (members || []).filter((m) => m.name.toLowerCase().includes(q.toLowerCase()));

  return (
    <div data-testid="admin-measurements-page">
      <PageHeader title="Ölçümler" subtitle="Bir üye seçerek ölçüm geçmişini görüntüle veya yeni ölçüm ekle" />
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Üye ara..." className="max-w-sm mb-4 bg-[#0E0E14] border-[#262636] text-white h-11" />
      {members === null ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">{[...Array(6)].map((_, i) => <Skeleton key={i} className="h-16 rounded-2xl bg-[#13131C]" />)}</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {filtered.map((m) => (
            <button key={m.id} onClick={() => navigate(`${base}/members/${m.id}`)} data-testid={`measurement-member-${m.id}`}
              className="flex items-center gap-3 p-4 rounded-2xl bg-[#13131C] border border-[#222230] hover:border-[#FF5500]/40 transition-all text-left group">
              <Avatar className="w-10 h-10"><AvatarFallback className="bg-[#1B1B27] text-[#FF5500] text-xs font-bold">{m.name.split(" ").map((w) => w[0]).slice(0, 2).join("")}</AvatarFallback></Avatar>
              <span className="flex-1 font-semibold text-white">{m.name}</span>
              <Ruler size={16} className="text-[#68687B]" />
              <ChevronRight size={16} className="text-[#68687B] group-hover:text-white" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
